(function () {
  document.addEventListener('DOMContentLoaded', () => {
    // Page d'accueil: changer le lien des collections vers la page Produits avec filtre activé.
    if (document.body.classList.contains('template-index')) {
      const links = document.querySelectorAll('a.categories-list__link');
      
      links.forEach(link => {
        const spanText = link.querySelector('span').textContent.trim();
        const newUrl = `/collections/all?filter.p.m.custom.filtre=${encodeURIComponent(spanText)}`;
        link.href = newUrl;
      });
    }
    // Page contact: ajouter un lien externe vers google sur l'image
    if(document.body.classList.contains('template-page-contact')) {
      const img = document.querySelector('.contact-form img');
      if(img) {
        const a = document.createElement('a');
        a.href = "https://www.google.com/maps/place/TECHNOSOLAR+SA/@46.570253,6.917869,17z/data=!4m6!3m5!1s0x478e86e162f5ccb1:0x54990279a235908a!8m2!3d46.570253!4d6.917869!16s%2Fg%2F1jkvf3fqt?hl=fr&entry=ttu";
        a.target = "_blank";
        img.parentNode.insertBefore(a, img);
        a.appendChild(img);

        // changer img en bg-image, pour bg-cover
        const parent = img.parentElement.parentElement;
        parent.style.backgroundImage = 'url(' + img.src + ')';
        parent.style.backgroundSize = 'cover';
        parent.style.backgroundPosition = 'center';
        parent.style.backgroundRepeat = 'no-repeat';
        img.style.display = 'none';
      }
    }
    // Hotfix formulaire d'addresses, faux label de Pays
    const observer = new MutationObserver(() => {
      const selectElement = document.querySelector('select[name="address[country]"]');
      if (selectElement) {
        const parentDiv = selectElement.closest('.select');
        const previousSibling = parentDiv.querySelector('.placeholder-select');

        if (previousSibling) {
          previousSibling.innerHTML = 'Pays <span>*</span>';
          observer.disconnect();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();
